import React from "react";
import { Mail, MapPin, Instagram } from "lucide-react";
import { footer } from "../mock";
import { Logo } from "./Header";
import { WhatsAppIcon } from "./WhatsAppWidget";

const renderIcon = (type) => {
  if (type === "whatsapp") return <WhatsAppIcon size={16} color="rgba(244,237,224,0.85)" />;
  if (type === "insta") return <Instagram size={16} style={{ opacity: 0.85 }} />;
  if (type === "mail") return <Mail size={16} style={{ opacity: 0.85 }} />;
  return <MapPin size={16} style={{ opacity: 0.85 }} />;
};

const Footer = () => {
  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer id="find-us" style={{ background: "var(--wine)", color: "var(--cream)" }}>
      <div className="max-w-[1360px] mx-auto px-6 md:px-10 py-20 grid md:grid-cols-3 gap-14">
        {/* Brand */}
        <div>
          <Logo size={72} />
          <h3 className="font-display text-3xl mt-8 leading-snug">
            {footer.tagline[0]}<br />
            <span className="italic">{footer.tagline[1]}</span>
          </h3>
        </div>

        {/* Explore */}
        <div>
          <span className="eyebrow" style={{ color: "rgba(244,237,224,0.55)" }}>EXPLORE</span>
          <ul className="mt-6 space-y-4">
            {footer.explore.map((e) => (
              <li key={e.label}>
                <button
                  onClick={() => scrollTo(e.href)}
                  className="link-underline font-body cursor-pointer text-left"
                  style={{ color: "rgba(244,237,224,0.9)" }}
                >
                  {e.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        {/* Find us */}
        <div>
          <span className="eyebrow" style={{ color: "rgba(244,237,224,0.55)" }}>FIND US HERE</span>
          <ul className="mt-6 space-y-5">
            {footer.contacts.map((c) => {
              const content = (
                <>
                  {renderIcon(c.type)}
                  <span className="font-body" style={{ color: "rgba(244,237,224,0.9)" }}>{c.label}</span>
                </>
              );
              return (
                <li key={c.label} className="flex items-center gap-3">
                  {c.href ? (
                    <a
                      href={c.href}
                      target="_blank"
                      rel="noreferrer"
                      className="flex items-center gap-3 group"
                    >
                      <span className="flex items-center gap-3 transition-opacity duration-300 group-hover:opacity-100" style={{ opacity: 0.9 }}>
                        {content}
                      </span>
                    </a>
                  ) : (
                    content
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      </div>

      <div className="max-w-[1360px] mx-auto px-6 md:px-10">
        <div className="py-8 flex flex-col md:flex-row justify-between gap-3" style={{ borderTop: "1px solid rgba(244,237,224,0.15)" }}>
          <span className="font-mono2" style={{ fontSize: "0.64rem", letterSpacing: "0.16em", color: "rgba(244,237,224,0.6)" }}>{footer.copyright}</span>
          <span className="font-mono2" style={{ fontSize: "0.64rem", letterSpacing: "0.16em", color: "rgba(244,237,224,0.6)" }}>{footer.note}</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
